import { ActivityTypeEnum } from './activities.types';

export const activityTypeLabels: Record<ActivityTypeEnum, string> = {
  [ActivityTypeEnum.BOXING]: 'Boxtraining',
  [ActivityTypeEnum.STRENGTH]: 'Krafttraining',
  [ActivityTypeEnum.RUNNING]: 'Lauftraining',
  [ActivityTypeEnum.OTHER]: 'Sonstiges Training',
};

export const activityTypeOptions: { value: ActivityTypeEnum; label: string }[] = [
  {
    value: ActivityTypeEnum.BOXING,
    label: activityTypeLabels[ActivityTypeEnum.BOXING],
  },
  {
    value: ActivityTypeEnum.STRENGTH,
    label: activityTypeLabels[ActivityTypeEnum.STRENGTH],
  },
  {
    value: ActivityTypeEnum.RUNNING,
    label: activityTypeLabels[ActivityTypeEnum.RUNNING],
  },
  {
    value: ActivityTypeEnum.OTHER,
    label: activityTypeLabels[ActivityTypeEnum.OTHER],
  },
];
